import { useEffect, useState } from "react";
import api from "../lib/api";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/audit-log").then((r) => setLogs(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="page-audit">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Audit Log</h1>
        <p className="text-sm text-muted-foreground mt-1">Tracked changes across the portfolio</p>
      </div>
      <div className="border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
              {["Time", "User", "Role", "Action", "Entity"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-border last:border-0 hover:bg-muted/50">
                <td className="px-4 py-3 font-mono text-xs">{new Date(l.timestamp).toLocaleString()}</td>
                <td className="px-4 py-3">{l.user}</td>
                <td className="px-4 py-3 capitalize">{l.role}</td>
                <td className="px-4 py-3 capitalize">{l.action}</td>
                <td className="px-4 py-3 capitalize">{l.entity}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-muted-foreground">No activity yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
